<template lang="pug">
div
  .month.mb-4
    v-menu(
      transition="slide-y-transition"
      open-on-hover
      offset-y
    )
        template(v-slot:activator="{on}")
          v-btn(v-on="on" color="accent").mr-2
            | {{ VIEW_TYPES_TEXT[type] }}
            v-icon(right) mdi-chevron-down
        v-list
          v-list-item(
            v-for="(item, index) in VIEW_TYPES"
            :key="index"
            :disabled="item === type ? true : false"
            @click="$emit('set-type', item)"
          ) {{ VIEW_TYPES_TEXT[item] }}
    v-btn.rounded.mr-2(fab x-small tile color="primary" @click="prev")
      v-icon mdi-chevron-left

    v-btn.rounded.mr-2(fab x-small tile color="primary" @click="next")
      v-icon mdi-chevron-right

    h6.text-h6.caption.mr-auto
      |  {{ MONTHS[currentDate.getMonth()] }} {{ currentDate.getFullYear() }}
    .flex-grow-1

    //- v-btn(color="success").mr-2 Всего: {{ schedules.length }}
    v-menu(
      transition="slide-y-transition"
      :close-on-content-click="false"
      offset-y
    )
      template(v-slot:activator="{ on }")
        v-badge(:value="hasSearchValues" content="1" left dot)
          v-btn(v-on="on")
            | Фильтр
            v-icon(right) mdi-filter
      v-card.pa-4
        v-text-field(filled label="Назавание вебинара" v-model="searchFields.name")
        v-text-field(filled label="Организатор" v-model="searchFields.organization_name")
        v-text-field(filled label="Кто ведет" v-model="searchFields.user_full_name")
        select-schedule-type(filled v-model="searchFields.type")
        v-btn(@click="clearFilter") Сбросить

</template>
<script>
import {
  addMonths, addWeeks, subMonths, subWeeks,
} from 'date-fns';
import { VIEW_TYPES, VIEW_TYPES_TEXT } from '../constants';
import { MONTHS } from '@/constants';
import SelectScheduleType from '@/components/inputs/SelectScheduleType.vue';

const DEFAULT_FIELDS = {
  name:'',
  type: null,
  organization_name: '',
  user_full_name: '',
};

export default {
  components:{ SelectScheduleType },
  props: {
    currentDate: { type: [String, Date], required: true },
    type: { type: [String, Date], required: true },
    schedules: { type: [String, Object, Array], required: true },
  },
  data() {
    return {
      MONTHS,
      VIEW_TYPES,
      VIEW_TYPES_TEXT,
      searchFields: {
        ...DEFAULT_FIELDS,
      },
    };
  },
  computed:{
    viewTypes() {
      return Object.keys(this.VIEW_TYPES_TEXT).map((key) => ({ value: key, text: this.VIEW_TYPES_TEXT[key] }));
    },
    month() {
      return MONTHS[this.currentDate.getMonth()];
    },
    hasSearchValues() {
      return Object.keys(this.searchFields).some((key) => this.searchFields[key]);
    },
  },
  watch:{
    searchFields: {
      deep: true,
      handler(v) {
        this.$emit('set-filters', v);
      },
    },
  },
  methods:{
    clearFilter() {
      this.searchFields = { ...DEFAULT_FIELDS };
    },
    next() {
      const add = {
        [VIEW_TYPES.MONTH]: addMonths,
        [VIEW_TYPES.WEEK]: addWeeks,
      };

      this.$emit('set-day', add[this.type](this.currentDate, 1));
    },
    prev() {
      const sub = {
        [VIEW_TYPES.MONTH]: subMonths,
        [VIEW_TYPES.WEEK]: subWeeks,
      };

      this.$emit('set-day', sub[this.type](this.currentDate, 1));
    },
  },

};
</script>

<style lang="scss">
.month {
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
